import { PropsWithChildren } from 'react';
import styles from './Grid.module.css';
import classNames from 'classnames';
import { HasStyle } from '~/types/HasStyle';

interface Breakpointable<TBreakpoint> {
  sm?: TBreakpoint;
  md?: TBreakpoint;
  lg?: TBreakpoint;
}

type Column = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

type Props = PropsWithChildren & { cols: Breakpointable<Column>; start?: Breakpointable<Column> };

// eslint-disable-next-line react-refresh/only-export-components
function GridRoot({ children, style }: PropsWithChildren & HasStyle) {
  return (
    <div className={styles.grid} style={style}>
      {children}
    </div>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
function Item(props: Props) {
  const { children, cols, start } = props;

  return (
    <div
      className={classNames(
        styles.item,

        cols.sm && styles[`sm-${cols.sm}`],
        cols.md && styles[`md-${cols.md}`],
        cols.lg && styles[`lg-${cols.lg}`],

        start?.sm && styles[`sm-start-${start.sm}`],
        start?.md && styles[`md-start-${start.md}`],
        start?.lg && styles[`lg-start-${start.lg}`]
      )}
    >
      {children}
    </div>
  );
}

export const Grid = Object.assign(GridRoot, {
  Item,
});
